var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8887 21.59V7.65C29.8887 3.42502 26.4636 0 22.2387 0L8.29868 0C4.0737 0 0.648666 3.42502 0.648666 7.65V21.59C0.648666 25.815 4.0737 29.24 8.29868 29.24H22.2387C26.4636 29.24 29.8887 25.815 29.8887 21.59Z",
    fill: "url(#paint0_linear_701_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13019 11.9003H11.9202V21.0003H9.13019V11.9003ZM10.5402 7.41027C10.8666 7.40635 11.1868 7.49994 11.4598 7.67907C11.7327 7.85821 11.946 8.11474 12.0723 8.4158C12.1985 8.71686 12.2321 9.04876 12.1686 9.369C12.1052 9.68924 11.9475 9.98325 11.716 10.2134C11.4844 10.4435 11.1894 10.5993 10.8688 10.6608C10.5482 10.7223 10.2165 10.6867 9.91621 10.5585C9.61593 10.4304 9.36074 10.2156 9.1833 9.94151C9.00586 9.66747 8.91425 9.3467 8.92019 9.02028C8.92543 8.59317 9.0981 8.18518 9.40106 7.88409C9.70403 7.583 10.1131 7.41286 10.5402 7.41027Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7305 11.9015H16.4505V13.1415C16.7257 12.6806 17.1196 12.302 17.5909 12.0452C18.0623 11.7884 18.594 11.6628 19.1305 11.6815C21.9905 11.6815 22.5205 13.5615 22.5205 16.0115V21.0115H19.7305V16.5815C19.7305 15.5815 19.7305 14.1715 18.2605 14.1715C16.7905 14.1715 16.5605 15.3215 16.5605 16.5115V21.0115H13.7305V11.9015Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_5",
    x1: 27.6387,
    y1: 2.25,
    x2: 2.88867,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0046E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8669a84832c2896659f268e7402fdb94.svg";
export { ForwardRef as ReactComponent };